






























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { EntityLocation, FeedTank, Node, Sensor, Transceiver } from '@/api';
import { FeedProductModals } from '../../../../models';

import TransceiverSuggest from '@/components/form pickers/transceiverSuggest.vue';
import SensorSuggest from '@/components/form pickers/sensorSuggest.vue';
import LocationInput from '@/components/form pickers/LocationInput.vue';
import Toast from '@/components/display/toast.vue';
import { EntityLocationService } from '@/services/entity-location-service';
import { Constants } from '@/common/Constants';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';
import NodeSuggest from '@/components/form pickers/nodeSuggest.vue';

@Component({
	components: {
		NodeSuggest,
		SaveCancelButtons,
		TransceiverSuggest,
		SensorSuggest,
		LocationInput,
	},
})
export default class InstallFeedTankModal extends Vue {
	@Prop({ required: true, type: Object })
	public feedTank!: FeedTank & {
		sensor: Sensor | null;
		transceiver: Transceiver | null;
	};

	@Prop({ required: true, type: Function })
	private onInstall!: (feedTank: FeedTank) => Promise<void>;

	@Watch('feedTank')
	public onFeedTankChanged(): void {
		this.resetValues();
	}

	public get transceiverId(): number | null {
		return this.transceiver?.id ?? null;
	}

	public transceiver: Partial<Transceiver> | null = this.feedTank.transceiver ?? null;
	public sensor: Sensor | null = this.feedTank.sensor ?? null;
	public node: Node | null = this.feedTank.sensor?.node ?? null;
	public sensorType: string = 'distance';
	public modalId: string = FeedProductModals.INSTALL_FEED_TANK;

	private toast: Toast = new Toast();

	public onTransceiverChanged(transceiver: Partial<Transceiver> | null): void {
		if (transceiver === null) {
			this.sensor = null;
		}
	}

	public async installFeedTank(): Promise<void> {
		if (!this.sensor?.id || !this.transceiver) {
			this.toast.makeToast('You must select a transceiver and a sensor', 'Error', 'danger');
			return;
		}
		this.feedTank.sensor = {
			...this.sensor,
			type: this.sensorType,
			node: this.node ?? undefined,
		};
		this.feedTank.transceiver = this.transceiver;
		await this.onInstall(this.feedTank);
	}

	public dismiss(): void {
		this.$bvModal.hide(FeedProductModals.INSTALL_FEED_TANK);
	}

	private resetValues(): void {
		this.transceiver = this.feedTank.transceiver ?? null;
		this.sensor = this.feedTank.sensor ?? null;
		this.node = this.feedTank.sensor?.node ?? null;
	}
}
